import { BudgetNotificationAlert } from "../../models/budget.model";

export const columnList = (alertValues: BudgetNotificationAlert[]) => [
    {
      field: 'Teams',
      forceDisplayColumName: ' ',
    },
    {
      field: 'Agents',
      forceDisplayColumName: ' ',
    },
    ...alertValues.map(av => ({
        field: av.name,
    }))
  ];

export const headerItemsNotification = (locale:string, groupLevelName: string) => [
    {
        cells: [
            {
                text: "GamificationAdmin",
                isLocalizedText: true,
                localizedSection: "Page_Names",
                fontColor: [0, 0, 0],
                bold: true,
            },
        ],
    }, // row 1
    {
        cells: [
            {
                text: "Budget_Notification",
                isLocalizedText: true,
                localizedSection: "Budget",
                fontColor: [0, 0, 0],
                bold: true,
            },
        ],
    }, // row 2
    {
        cells: [
            {
                text: "Company_Header",
                isLocalizedText: true,
                localizedSection: "Budget",
            },
            {
                customName: "CompanyName",
            },
        ],
    }, // row 3
    {
        cells: [
            {
                text: "Month_Header",
                isLocalizedText: true,
                localizedSection: "Budget",
            },
            {
                text: new Date().toLocaleString(locale, { month: "long" }),
                isLocalizedText: true,
                localizedSection: "Common",
            },
        ],
    }, // row 4
    {}, // row 5
    {
        cells: [
            {
                text: groupLevelName,
                fontColor: [255, 255, 255],
                backgroundColor: [0, 120, 172],
                bold: true,
                borderBottom: true,
                borderLeft: true,
                borderColor: [0, 0, 0],
                borderTop: true,
                borderRight: true,
            },
            {
                text: "State_Agents",
                isLocalizedText: true,
                localizedSection: "Module",
                fontColor: [255, 255, 255],
                backgroundColor: [0, 120, 172],
                bold: true,
                borderBottom: true,
                borderLeft: true,
                borderColor: [0, 0, 0],
                borderTop: true,
                borderRight: true,
            },
            {
                text: "Enable_Notifications",
                isLocalizedText: true,
                localizedSection: "Budget",
                fontColor: [255, 255, 255],
                backgroundColor: [0, 120, 172],
                bold: true,
                mergedCells: 4,
                borderBottom: true,
                borderLeft: true,
                borderColor: [0, 0, 0],
                borderTop: true,
                borderRight: true,
            },
        ],
    }, // row 6
];